// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section{display:flex;flex-direction:column;margin-left:auto;margin-right:auto;width:100%;max-width:1024px;margin-bottom:128px;padding-left:1.5rem;padding-right:1.5rem}@media screen and (min-width:48em){.section{margin-bottom:200px}}@media screen and (min-width:48em){.section--small{margin-bottom:6rem}}.section--fluid{margin-left:unset;margin-right:unset;max-width:unset}.section--mint{background:#00ffa3;color:#252837}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
